import { Headset, LayoutList, Star, PackageCheck } from "lucide-react";

const VALUES = [
  { icon: Headset, title: "Ücretsiz Danışmanlık", text: "Otel açılış sürecinizde A'dan Z'ye uzman rehberliği. Satıştan öte stratejik partnerlik." },
  { icon: LayoutList, title: "Oda Bazlı Planlama", text: "Oda tipinize ve yıldız hedefinize göre kişiselleştirilmiş ekipman listesi." },
  { icon: Star, title: "Yıldız Standartlarına Uygun", text: "Turizm Bakanlığı gereksinimleriyle %100 uyumlu ekipman tedariki." },
  { icon: PackageCheck, title: "Tek Noktadan Çözüm", text: "Buklet ürünlerinden restoran ekipmanlarına — tüm kategoriler tek kaynaktan." },
];

export default function ValueCards() {
  return (
    <section className="section-pad bg-softbg" data-testid="value-cards">
      <div className="container-site">
        <div className="text-center mb-14">
          <p className="accent-script text-gold text-2xl mb-1">Farkımız</p>
          <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy">Neden Otel Pro?</h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
            Sadece ürün satmıyoruz; otelinizin açılışının her aşamasında, yıldız standartlarından
            ekipman yerleşimine kadar stratejik bir iş ortağı olarak yanınızdayız.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {VALUES.map((v, i) => (
            <div key={v.title} className="card-premium p-7 text-left" data-testid={`value-card-${i}`}>
              <div className="h-11 w-11 rounded-md bg-navy text-gold flex items-center justify-center mb-5">
                <v.icon size={20} />
              </div>
              <h3 className="heading-serif text-lg font-semibold text-navy mb-2">{v.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
